export type DashboardRoute =
  | { kind: "report"; id: string }
  | { kind: "record"; id: string }
  | null;

export type PublicRoute = "privacy" | "terms" | "refund" | "support" | "delete-account" | null;

const uuid = "[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}";

export function parseDashboardRoute(pathname: string): DashboardRoute {
  const match = pathname.toLowerCase().match(new RegExp(`^/(reports|records)/(${uuid})/?$`));
  if (!match) return null;
  return { kind: match[1] === "reports" ? "report" : "record", id: match[2] };
}

export function parsePublicRoute(pathname: string): PublicRoute {
  const match = pathname.toLowerCase().match(/^\/(privacy|terms|refund|support|delete-account)\/?$/);
  return match ? match[1] as Exclude<PublicRoute, null> : null;
}

export function isBetaRoute(pathname: string): boolean {
  return /^\/beta\/?$/i.test(pathname);
}

export function parseInvitationToken(pathname: string, search: string): string | null {
  if (!/^\/join\/?$/i.test(pathname)) return null;
  const token = new URLSearchParams(search).get("token");
  return token && /^[0-9a-f]{64}$/i.test(token) ? token.toLowerCase() : null;
}

export function isBillingRoute(pathname: string): boolean {
  return /^\/billing\/?$/i.test(pathname);
}
